export default {"src":"/_next/static/media/link-external-icon.cc1d7ffe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};